import { openModal } from '@core/components/ModalStack';
import { ProcessPaymentModalProps } from './ProcessPaymentModal';
import { ManualPaymentModalProps } from './ManualPaymentModal';
import { RefundPaymentModalProps } from './RefundPaymentModal';

export async function openProcessPaymentModal(props: ProcessPaymentModalProps) {
  const { ProcessPaymentModal } = await import('./ProcessPaymentModal');

  openModal(ProcessPaymentModal, props);
}

export async function openManualPaymentModal(props: ManualPaymentModalProps) {
  const { ManualPaymentModal } = await import('./ManualPaymentModal');

  openModal(ManualPaymentModal, props);
}

export async function openRefundPaymentModal(props: RefundPaymentModalProps) {
  const { RefundPaymentModal } = await import('./RefundPaymentModal');

  openModal(RefundPaymentModal, props);
}
